module.exports = __webpack_public_path__ + "img/boy.dd863101.png";